<template>
  <v-container>
    <v-card outlined width="auto" class="">
      <v-card-title>
        <h3 class="mb-0 font-weight-regular">Validação da autorização</h3>
      </v-card-title>
      <v-divider class="mb-8"></v-divider>
      <v-card-text class="d-flex flex-column justify-center">
        <section class="d-flex flex-row" style="gap: 20px">
          <v-text-field
            label="Token"
            class="ma-0"
            :value="token"
            disabled
            style="font-weight: bold"
          />
          <v-text-field
            label="Validade"
            class="ma-0 text--primary"
            :value="dataValidade"
            style="font-weight: bold"
            disabled
          />
        </section>
        <v-alert v-if="status === 'VALIDA'" type="success" class="mt-5">
          Autorização válida.
        </v-alert>
        <v-alert v-else-if="status === 'VENCIDA'" type="error" class="mt-5">
          Autorização vencida.
        </v-alert>
        <v-alert v-else-if="status === 'invalid'" type="warning" class="mt-5" outlined>
          Certificado não encontrado.
        </v-alert>
        <v-progress-circular v-else indeterminate color="primary" class="mt-5" />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import solicitacaoService from '@/services/spgc/solicitacao.service';
import moment from 'moment';

export default {
  name: 'ValidarAutorizacao',
  data() {
    return {
      status: '', // 'VALIDA', 'VENCIDA' ''
      token: '',
      protocolo: '',
    };
  },
  mounted() {
    this.token = this.$route.query.token;
    this.protocolo = this.$route.query.protocolo;
    this.status = '';
    this.validateAutorizacao();
    this.dataValidade = '';
  },
  methods: {
    validateAutorizacao() {
      solicitacaoService.checkValidAutorizacao(this.token, this.protocolo).subscribe({
        next: res => {
          const result = res.result || {};
          // Verifica validade
          const validade = result.dataValidade;
          this.dataValidade = moment(validade).format('DD/MM/YYYY');
          if (validade) {
            const hoje = new Date();
            const dataValidade = new Date(validade);
            // Considera válida se dataValidade >= hoje (ignora hora)
            hoje.setHours(0, 0, 0, 0);
            dataValidade.setHours(0, 0, 0, 0);
            if (dataValidade >= hoje) {
              this.status = 'VALIDA';
              return;
            } else {
              this.status = 'VENCIDA';
              return;
            }
          }
          // Se não tem dataValidade, considera inválido
          this.status = 'VENCIDA';
        },
        error: err => {
          this.status = 'invalid';
          console.error(err);
        },
      });
    },
  },
};
</script>
